import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { ToastrService } from 'ngx-toastr';
import { ProcesosActivosService } from 'src/app/services/procesosactivos.service';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-siderbar',
  templateUrl: './siderbar.component.html',
  styleUrls: ['./siderbar.component.css']
})
export class SiderbarComponent implements OnInit {
  @Input() Navegacion: any[];

  subnav = false;
  nroSimulaciones: number = -1;
  // userData: Contact = null;
  procesado: boolean = false;
  ProcesosActivosSubscribe: Subscription;
  postulacionesListaEspera: string = null
  user: any = null
  loadingNuevoProceso: boolean = false
  carrera: any;

  get tieneCarrerasListaEspera() {
    return this.postulacionesListaEspera && this.postulacionesListaEspera.length > 0
  }

  constructor(
    private router: Router,
    private procesoMatriculaService: ProcesoMatriculaService,
    private auths: AuthService,
    private contactservice: ContactService,
    public alerts: ToastrService,
    private procesosActivosService: ProcesosActivosService) {
    if (this.router.url.startsWith('/proceso')) {
      this.subnav = true;
    }

  }

  ngOnDestroy(): void {
    this.ProcesosActivosSubscribe.unsubscribe();
  }
  ngOnInit(): void {
    this.loadUserData();

    this.ProcesosActivosSubscribe = this.procesosActivosService.procesosActivos$.subscribe(async value => {
      // console.log('ProcesosActivosSubscribe', value)
      if (value === 'LOAD_PROCESOS') {
        this.procesado = false;
        this.loadUserData();
      }
    });
  }

  async loadUserData() {
    this.user = this.auths.GetUserToken();
    if (this.user !== null) {
      await this.loadCantidadSimulaciones()
    }
  }

  async loadCantidadSimulaciones() {
    const data: any = await this.procesoMatriculaService.GetCantidadSimulaciones(this.user.primarysid).toPromise()
    this.nroSimulaciones = data;
    this.procesado = true;
  }

  async TryCrearNuevoProceso() {
    try {
      this.loadingNuevoProceso = true

      // limpiar
      this.postulacionesListaEspera = ''

      const esPosiblePorNroProcesos = await this.validarNroProcesos();

      if (!esPosiblePorNroProcesos) {
        this.loadingNuevoProceso = false
        return;
      }

      if (this.user.BloqueoAcademico !== null) {
        if (this.user.BloqueoAcademico === 'True') {
          this.openModalBloqueoAcademico();
        }
      }

      // Comprobar la existencia de postulaciones
      const existePostulacionResponse: any = await this.contactservice.ExistePostulacionRut(this.user.Rut, this.user.Dv).toPromise()
      const postulacionesEstado24 = existePostulacionResponse.filter(p => p.estadoPost === 24)

      if (postulacionesEstado24.length === 0) {
        const postulacionesEstado25 = existePostulacionResponse.filter(p => p.estadoPost === 25).map(p => p.nombreCarrera).join(', ')
        if (postulacionesEstado25.length === 0) {
          this.alerts.info('No es posible crear un nuevo proceso', 'Información'); //, { positionClass: 'inline' });
          this.loadingNuevoProceso = false
          return
        }
        this.carrera = existePostulacionResponse[0].nombreCarrera
        console.log('LA CARRERA ', this.carrera)
        this.postulacionesListaEspera = postulacionesEstado25
        this.openModalListaDeEspera()
        this.loadingNuevoProceso = false
        return
      }

      // Servicio Crea Postulación
      const creaProcesoResponse: any = await this.procesoMatriculaService.CreaProcesoCentralizada(this.user.Rut, this.user.Dv).toPromise()
      const { Id: idProceso, Error } = creaProcesoResponse.Result
      if (Error) {
        this.alerts.error('No fue posible crear el proceso', 'Error')
        this.loadingNuevoProceso = false
        return
      }

      // Servicio Set Fase Carrera Convocada
      const etapaProceso = '1'
      this.procesoMatriculaService.setFase(idProceso, etapaProceso).subscribe(
        (data) => {
          ++this.nroSimulaciones
          this.router.navigateByUrl(`/proceso/${idProceso}`);
          this.loadingNuevoProceso = false
        },
        (err) => {
          console.log(err);
          this.loadingNuevoProceso = false
        }
      );

      await this.loadCantidadSimulaciones()
    } catch {
      this.loadingNuevoProceso = false
    }
  }

  async validarNroProcesos() {
    const cantidadMaximaProcesos: number = 1

    if (!this.procesado) {
      this.alerts.info('Cargando data', 'Información', { positionClass: 'inline' });
      return false;
    }

    if (this.nroSimulaciones >= cantidadMaximaProcesos) {
      $('#maximoProcesosActivosModal').modal('show');
      return false;
    }

    return true;
  }

  openModalBloqueoAcademico() {
    $('#modalBloqueoAcademico').modal('show');
  }

  openModalListaDeEspera() {
    console.log('openModalListaDeEspera')
    $('#modalListaDeEspera').modal('show');
  }

  showMessageLoadingNuevoProceso() {
    this.alerts.info('Se está procesando la información', 'Espere', { positionClass: 'inline' })
  }

}
